
import { WorldCountry } from './types';

export const turkeyData: WorldCountry = {
  code: 'TR',
  name: 'Turkey',
  slug: 'turkey',
  population: 84339067,
  topCities: [
    { name: 'Istanbul', slug: 'istanbul', population: 15519267 },
    { name: 'Ankara', slug: 'ankara', population: 5663322 },
    { name: 'Izmir', slug: 'izmir', population: 4394694 },
    { name: 'Bursa', slug: 'bursa', population: 3101833 },
    { name: 'Antalya', slug: 'antalya', population: 2619832 },
    { name: 'Adana', slug: 'adana', population: 2274106 },
    { name: 'Konya', slug: 'konya', population: 2232374 },
    { name: 'Gaziantep', slug: 'gaziantep', population: 2154051 },
    { name: 'Sanliurfa', slug: 'sanliurfa', population: 2115256 },
    { name: 'Mersin', slug: 'mersin', population: 1891145 }
  ]
};
